import React from "react";
import { FinancialConnection } from "@common/types/financialConnection";
import { IntegrationAccount } from "@common/types/integrationAccount";
import { IntegrationConnection } from "@common/types/integrationConnection";
import { ConfirmationModal } from "@design-system/Modal/ConfirmationModal";
import { ConnectionFixer } from "@components/financialConnection/ConnectionFixer";

interface Props {
    connection: FinancialConnection | IntegrationConnection;
    integrationAccount?: IntegrationAccount;
    show: boolean;
    onContinue: () => void;
    onCancel: () => void;
}

const CONTINUE_LABEL = "Continue with disconnected";

export const DisconnectedReconcileWarning: React.FC<Props> = ({
    connection,
    integrationAccount,
    show,
    onContinue,
    onCancel,
}) => (
    <ConnectionFixer
        connection={connection}
        integrationAccount={integrationAccount}
        onFixed={onContinue}
    >
        {(fix) => (
            <ConfirmationModal
                show={show}
                title="Account is disconnected"
                question="This account isn't syncing new transactions, so the reconciliation may miss recent activity. Reconnect it first, or continue with the data already imported."
                yes={fix.canFix ? "Reconnect" : CONTINUE_LABEL}
                onConfirm={fix.canFix ? fix.startFix : onContinue}
                confirmLoading={fix.canFix && fix.isFixing}
                alternative={
                    fix.canFix
                        ? {
                              label: CONTINUE_LABEL,
                              variant: "secondary",
                              onConfirm: onContinue,
                          }
                        : undefined
                }
                no="Cancel"
                noBtnVariant="secondary"
                onReject={onCancel}
                onHide={fix.canFix && fix.isFixing ? undefined : onCancel}
            />
        )}
    </ConnectionFixer>
);
